// Typed wrapper for `/api/v1/health/dashboard` — system health
// dashboard rollup (issue #23).
//
// Mirrors `crates/api/src/health.rs::HealthCheck`. Renaming a field
// there means renaming it here too.

import { api } from "@/lib/api";

/** Severity drives chip colour and the page-level rollup. */
export type HealthSeverity = "ok" | "warning" | "error";

export interface HealthCheck {
  /** Stable identifier, used to map check rows to icons + copy. */
  id: string;
  severity: HealthSeverity;
  /** Short eyebrow-style label. */
  title: string;
  /** One-line factual statement. */
  message: string;
  /** Optional deep-link path into the offending settings page. */
  link: string | null;
}

export const healthApi = {
  /** Fetch the flat list of health checks. The backend already runs
   *  every check concurrently, so a single GET is the whole picture. */
  dashboard: () => api<HealthCheck[]>("/api/v1/health/dashboard"),
};
